import membership from './membership';

const permissions = {
  membership,
};

export default permissions;
